module.exports = "/_next/static/images/15311f32f8d401ebb3252e28c70baaa6-locked-deposits@3x.jpg";